import {forwardRef, type HTMLAttributes} from 'react'

import classNames from 'classnames'
import styles from './SectionWrapper.module.scss'

export type SectionWrapperProps = HTMLAttributes<HTMLDivElement>

export const SectionWrapper = forwardRef<HTMLDivElement, SectionWrapperProps>(
    ({id, className, children, ...props}, ref) => {
        return (
            <section
                id={id}
                className={classNames(styles.SectionWrapper, className)}
                ref={ref}
                {...props}
            >
                {children}
            </section>
        )
    },
)
SectionWrapper.displayName = 'SectionWrapper'
